import {
  Box,
  mdBumps,
  Section,
  SectionContent,
  SectionDescription,
  SectionProps,
  SectionTitle,
} from '@wrisk/ui-components'
import React, { FunctionComponent } from 'react'

import { CoverOption, Quote } from '../../../domain'
import { TKey, useWriskTranslation } from '../../../infrastructure/internationalisation'
import { CoverEndorsements } from './CoverEndorsements'
import { IncludedCoverItems } from './IncludedCoverItems'
import { OptionalCoverItems } from './OptionalCoverItems'

export interface CoverSectionProps extends SectionProps {
  quote: Quote
  onChange?: (cover: CoverOption) => void
}

const tKey = TKey('components.cover-section')

export const CoverSection: FunctionComponent<CoverSectionProps> = ({
  quote,
  onChange,
  ...props
}) => {
  const { t } = useWriskTranslation()

  const subheader = t(tKey('subheader'), { defaultValue: null })

  return (
    <Section width={1} {...props}>
      <SectionTitle>{t(tKey('header'))}</SectionTitle>
      {subheader && <SectionDescription>{subheader}</SectionDescription>}
      <SectionContent>
        <Box width={1} variant='raised'>
          <IncludedCoverItems quote={quote} />
          <OptionalCoverItems quote={quote} onChange={onChange} />
        </Box>
      </SectionContent>
      <CoverEndorsements quote={quote} mt={mdBumps} />
    </Section>
  )
}
